function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import { branch, compose, renderNothing, setPropTypes, withHandlers, withPropsOnChange, withStateHandlers } from 'recompose';
import { connect } from 'react-redux';
import { getFormSyncErrors, reduxForm, submit } from 'redux-form';
import PropTypes from 'prop-types';
import QuestionsModal from "./QuestionsModal";
import { patchApplicationRequirementAnswerAction, postApplicationRequirementAnswerAction } from "../../../../api/jsonapi";
import componentErrorBoundary from "../../../../components/enhancers/componentErrorBoundary";
import withBodyNoScroll from "../../../../components/enhancers/withBodyNoScroll";
import { isAllEmpty } from "../../../../util/common";
import handleApiErrorResponse from "../../../../util/handleApiErrorResponse";
// eslint-disable-line import/no-unresolved
import { raiseSuccessMessage } from '@applyboard/ui-utils';
var FORM_NAME = 'answer_questions';
var validateQuestions = function validateQuestions(values, _ref) {
  var normalStatusQuestions = _ref.normalStatusQuestions,
    duplicateQuestionsVisible = _ref.duplicateQuestionsVisible;
  var errors = {};

  // only worried about normal status questions, must be at least one in order to submit
  if (!normalStatusQuestions || normalStatusQuestions.length <= 0) {
    errors.disableSubmit = true;
    return errors;
  }
  if (isAllEmpty(values)) {
    errors.disableSubmit = true;
    return errors;
  }

  // make sure all questions with normal status have a value
  normalStatusQuestions.forEach(function (question) {
    var answer = values["answer-".concat(question.answer ? question.answer.id : question.id).concat(question.duplicated ? '-duplicated' : '')];
    if (question.duplicated && duplicateQuestionsVisible && !answer || !question.duplicated && !answer) {
      errors.disableSubmit = true;
      return errors;
    }
    if (question.question_format === 'checkboxes' && answer.length <= 0) {
      if (question.duplicated && duplicateQuestionsVisible || !question.duplicated) {
        errors.disableSubmit = true;
        return errors;
      }
    }
  });
  return errors;
};
var enhancer = compose(componentErrorBoundary, branch(function (_ref2) {
  var questionsModalVisible = _ref2.questionsModalVisible;
  return !questionsModalVisible;
}, renderNothing), withBodyNoScroll(), connect(function (state) {
  return {
    formSyncErrors: getFormSyncErrors('answer_questions')(state)
  };
}, function (dispatch, _ref3) {
  var requirementId = _ref3.requirementId;
  return {
    updateQuestionAnsweredStoreAction: function updateQuestionAnsweredStoreAction(question_data) {
      return dispatch({
        type: 'UPDATE_QUESTION_ANSWERED',
        data: question_data,
        requirement_id: requirementId
      });
    },
    answerQuestions: function answerQuestions() {
      return dispatch(submit('answer_questions'));
    },
    applicationRequirementAnswer: function applicationRequirementAnswer(question_id, answer) {
      return dispatch(postApplicationRequirementAnswerAction({
        application_requirement_id: requirementId,
        question_id: question_id
      }, {
        data: {
          attributes: {
            answer: answer
          }
        }
      }));
    },
    applicationRequirementUpdateAnswer: function applicationRequirementUpdateAnswer(question_id, id, answer) {
      return dispatch(patchApplicationRequirementAnswerAction({
        application_requirement_id: requirementId,
        question_id: question_id,
        id: id
      }, {
        data: {
          attributes: {
            answer: answer
          }
        }
      }));
    }
  };
}), withStateHandlers({
  apiErrors: {}
}, {
  setApiError: function setApiError(_ref4) {
    var apiErrors = _ref4.apiErrors;
    return function (questionId, apiErrorList) {
      return {
        apiErrors: _objectSpread(_objectSpread({}, apiErrors), {}, _defineProperty({}, questionId, apiErrorList))
      };
    };
  }
}), withStateHandlers({
  waitingForSubmit: false
}, {
  setWaitingForSubmit: function setWaitingForSubmit() {
    return function (waitingForSubmit) {
      return {
        waitingForSubmit: waitingForSubmit
      };
    };
  }
}), withPropsOnChange(['questions'], function (_ref5) {
  var questions = _ref5.questions;
  var duplicatedQuestions = questions.filter(function (q) {
    return q.duplicated;
  });
  var normalStatusQuestions = questions.filter(function (q) {
    return q.status === 'normal';
  });
  var initialValues = {};
  questions.forEach(function (q) {
    if (!q.duplicated) {
      if (q.answer) {
        initialValues["answer-".concat(q.answer.id)] = q.answer.answer;
      } else {
        initialValues["answer-".concat(q.id)] = '';
      }
    } else {
      initialValues["answer-".concat(q.id, "-duplicated")] = '';
    }
  });
  return {
    duplicatedQuestions: duplicatedQuestions,
    normalStatusQuestions: normalStatusQuestions,
    initialValues: initialValues
  };
}), withHandlers({
  onSubmit: function onSubmit(_ref6) {
    var applicationRequirementAnswer = _ref6.applicationRequirementAnswer,
      applicationRequirementUpdateAnswer = _ref6.applicationRequirementUpdateAnswer,
      onToggleQuestionsModal = _ref6.onToggleQuestionsModal,
      normalStatusQuestions = _ref6.normalStatusQuestions,
      updateQuestionAnsweredStoreAction = _ref6.updateQuestionAnsweredStoreAction,
      onSuccess = _ref6.onSuccess,
      setApiError = _ref6.setApiError,
      setWaitingForSubmit = _ref6.setWaitingForSubmit;
    return /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
        var promises;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // only answer questions with normal status
              promises = normalStatusQuestions.map( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(question) {
                  var questionAnswerPromise, answer, _answer, questionAnswerResponse;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        questionAnswerPromise = null; // for already answered questions, only submit if value is different from api loaded answer
                        _context.prev = 1;
                        if (question.answer) {
                          answer = question.duplicated ? values["answer-".concat(question.answer.id, "-duplicated")] : values["answer-".concat(question.answer.id)];
                          if (answer !== question.answer.answer) {
                            setWaitingForSubmit(true);
                            questionAnswerPromise = applicationRequirementUpdateAnswer(question.id, question.answer.id, answer);
                          }
                        } else {
                          _answer = question.duplicated ? values["answer-".concat(question.id, "-duplicated")] : values["answer-".concat(question.id)];
                          if (_answer && _answer !== '') {
                            setWaitingForSubmit(true);
                            questionAnswerPromise = applicationRequirementAnswer(question.id, _answer);
                          }
                        }
                        _context.next = 5;
                        return questionAnswerPromise;
                      case 5:
                        questionAnswerResponse = _context.sent;
                        if (questionAnswerResponse) {
                          updateQuestionAnsweredStoreAction(questionAnswerResponse.body.data);
                          setApiError(question.id, undefined);
                        }
                        _context.next = 15;
                        break;
                      case 9:
                        _context.prev = 9;
                        _context.t0 = _context["catch"](1);
                        handleApiErrorResponse(_context.t0);
                        console.error('error');
                        console.error({
                          question: question,
                          error: _context.t0
                        });
                        if (_context.t0.body && _context.t0.body.errors) setApiError(question.id, _context.t0.body.errors);
                      case 15:
                        return _context.abrupt("return", questionAnswerPromise);
                      case 16:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[1, 9]]);
                }));
                return function (_x2) {
                  return _ref8.apply(this, arguments);
                };
              }());
              _context2.prev = 1;
              _context2.next = 4;
              return Promise.all(promises);
            case 4:
              setWaitingForSubmit(false);
              raiseSuccessMessage('All answers submitted successfully');
              onToggleQuestionsModal();
              onSuccess();
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              /* already handled above. */
              setWaitingForSubmit(false);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 10]]);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }();
  },
  reduxFormSubmit: function reduxFormSubmit(_ref9) {
    var answerQuestions = _ref9.answerQuestions;
    return function () {
      return answerQuestions();
    };
  }
}), withStateHandlers(function (_ref10) {
  var duplicatedQuestions = _ref10.duplicatedQuestions,
    requirementStatus = _ref10.requirementStatus;
  return {
    duplicateQuestionsVisible: false,
    showRetryRejectionsText: requirementStatus !== 'completed' && duplicatedQuestions && duplicatedQuestions.length > 0
  };
}, {
  onShowDuplicateQuestions: function onShowDuplicateQuestions() {
    return function () {
      return {
        duplicateQuestionsVisible: true,
        showRetryRejectionsText: false
      };
    };
  }
}), reduxForm({
  form: FORM_NAME,
  touchOnChange: true,
  validate: validateQuestions,
  enableReinitialize: true
}), setPropTypes({
  formSyncErrors: PropTypes.object,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onToggleQuestionsModal: PropTypes.func,
  onToggleReAnswerQuestion: PropTypes.func,
  onToggleReTryRejections: PropTypes.func,
  questions: PropTypes.array,
  questionsModalVisible: PropTypes.bool,
  reAnswerEnabled: PropTypes.bool,
  reTryRejections: PropTypes.bool,
  reduxFormSubmit: PropTypes.func,
  requirementId: PropTypes.number,
  requirementTitle: PropTypes.string,
  onSuccess: PropTypes.func
}));
export default enhancer(QuestionsModal);